import React from "react"
import { Typography, Slider, MenuItem, Select } from "@material-ui/core";

import './user-form.scss'

export function UserForm({onUserSubmit, props}) {
    const dataTypes = [
        {
            name: 'Superstore',
            id: 0
        },{
            name: 'Supermarket',
            id: 1
        },{
            name: 'Medical',
            id: 2
        }
    ]

    const [size, setSize] = React.useState(5000)
    const [dataType, setDataType] = React.useState(dataTypes[0].id)

    function handleSizeChange(event, newValue) {
        setSize(newValue)
    }

    function handleDataTypeChange(event) {
        setDataType(event.target.value)
    }

    function handleSubmit(event) {
        event.preventDefault()
        onUserSubmit({
            size,
            dataType
        })
    }

    return (
        <form onSubmit={handleSubmit} {...props}>
            <div className="element">
                <Typography id="size-slider" gutterBottom>
                    Number of data rows: <span className="size-value">{size}</span> 
                </Typography>
                <Slider
                    value={size}
                    onChange={handleSizeChange}
                    aria-labelledby="size-slider"
                    min={150}
                    max={10000}
                    valueLabelDisplay="off"
                />
            </div>

            <div className="element">
                <Typography id="data-type-select">Data Type</Typography>
                <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={dataType}
                aria-labelledby="data-type-select"
                onChange={handleDataTypeChange}>
                    <MenuItem value={dataTypes[0].id}>{dataTypes[0].name}</MenuItem>
                    <MenuItem value={dataTypes[1].id}>{dataTypes[1].name}</MenuItem>
                    <MenuItem value={dataTypes[2].id}>{dataTypes[2].name}</MenuItem>
                </Select>
            </div>
            <div className="element">
                <input className="submit-btn btn btn-singularit" type="submit" value="Generate Synthetic Data" />
            </div>
        </form>
    )
}